const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export function offerUsd(sats: number | null | undefined, rate: number | null | undefined) {
	if (
		sats == null ||
		!Number.isFinite(sats) ||
		sats < 0 ||
		rate == null ||
		!Number.isFinite(rate) ||
		rate <= 0
	)
		return null
	const value = (sats / 1e8) * rate
	if (!Number.isFinite(value)) return null
	return value > 0 && value < 0.01 ? '< $0.01 USD' : `≈ ${usd.format(value)} USD`
}
